// extracted by mini-css-extract-plugin
export default {"container":"Devis_container__D2Yc+","buttonContainer":"Devis_buttonContainer__fEMJA"};